"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    // ======================================================
    notFoundPage: {
      message: 'Item or Page not Found or You do not have Permissions.'
    },
    loginPage: {
      title: 'Sprinx CRM Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login'
    },
    loginErrorPage: {
      title: 'Login failed',
      error: 'Login failed. User name or password not found.',
      pleaseRelogin: 'It seems that You are not authenticate. Please authenticate again.'
    },
    oauthLogin: {
      message: 'You have to sign in. Please choose one of listed authentication providers',
      loginButton: 'Login with Sprinx',
      redirecting: 'Waiting for redirection to the authentication server...'
    },
    logout: {
      inProgress: 'Loggin you out...',
      error: 'Logout error',
      gotoHome: 'Redirect me to home',
      success: 'You have been successfully signed out.'
    }
  }
};
var _default = messages;
exports.default = _default;